// extracted by mini-css-extract-plugin
export default {"resetPasswordContent":"t7SHEc","resetPasswordInput":"CrLEUh"};